<div class="ui-g-12">
  <app-kontable
    #table
    title="{{ 'catalog.giftsType' | translate }}"
    [columns]="[
      {field: 'id', title: 'ID'},
      {field: 'code', title: 'catalog.code'},
      {field: 'description', title: 'catalog.description'},
      {field: 'template_reserv', title: 'catalog.template_reserv'},
      {field: 'template_pickup', title: 'catalog.template_pickup'},
      {field: 'template_delete', title: 'catalog.template_delete'}
    ]"
    [service]="catalogTypeGiftService"
    [paginationType]="paginationType"
    (onEdit)="editCatalog($event.id)"
    (onAdd)="addCatalog()"
    (onRemove)="deleteCatalog($event.id, table)"
    [showRecoverButton]="false"
    [showInfoButton]="false"
    [showAddButton]="true"
    [showDeleteButton]="true"
    [showDetailsButton]="false"
    [showEditButton]="true"
    [showReport]="true"
  >
  </app-kontable>
</div>



// WEBPACK FOOTER //
// ./src/app/views/promotion/catalog-gift-type/catalog-gift-type.component.html